import { router } from "@inertiajs/react";
import Header from "../Component/Header";

const formatNumber = (value) =>
    new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    }).format(Number(value) || 0);

const formatBiaya = (item) => {
    const biaya = Number(item?.biaya) || 0;
    const percentType = String(item?.percent || "").toLowerCase();

    if (percentType === "percent") {
        return `${formatNumber(biaya)}%`;
    }

    return `Rp ${new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(biaya)}`;
};

const formatRupiah = (value) =>
    `Rp ${new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(Number(value) || 0)}`;

export default function Index({ data = [] }) {
    const feeTypeMeta = (value) => {
        if (Number(value) === 2) {
            return {
                label: "Include",
                className: "bg-amber-100 text-amber-700",
            };
        }

        return {
            label: "Exclude",
            className: "bg-green-100 text-green-700",
        };
    };

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <div className="flex flex-wrap justify-between items-center gap-3">
                            <div>
                                <h1 className="text-lg md:text-xl font-semibold text-foreground">
                                    Payment Method List
                                </h1>
                                <p className="text-sm text-muted-foreground-1">
                                    Manage payment channels used on checkout.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => router.visit("/panel/create-payment-method-list")}
                                className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground hover:bg-layer-hover"
                            >
                                Add Payment Method
                            </button>
                        </div>

                        <div className="bg-card border border-card-line rounded-xl shadow-2xs p-5">
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-table-line">
                                    <thead>
                                        <tr>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Kode</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Nama</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Metode</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Tipe</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Range</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Biaya</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Adm Fee</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Status</th>
                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-table-line">
                                        {data.length === 0 ? (
                                            <tr>
                                                <td colSpan={9} className="py-6 px-4 text-center text-sm text-muted-foreground-2">
                                                    No payment method data found.
                                                </td>
                                            </tr>
                                        ) : (
                                            data.map((item) => (
                                                <tr key={item.pml_id} className="hover:bg-surface">
                                                    <td className="py-3 px-4 text-sm text-foreground">{item.kode}</td>
                                                    <td className="py-3 px-4 text-sm text-muted-foreground-2">{item.nama || "-"}</td>
                                                    <td className="py-3 px-4 text-sm text-muted-foreground-2">{item.metode || "-"}</td>
                                                    <td className="py-3 px-4 text-sm text-muted-foreground-2">{item.tipe || "-"}</td>
                                                    <td className="py-3 px-4 text-sm text-muted-foreground-2">
                                                        {formatRupiah(item.minimal)} - {formatRupiah(item.maksimal)}
                                                    </td>
                                                    <td className="py-3 px-4 text-sm text-muted-foreground-2">{formatBiaya(item)}</td>
                                                    <td className="py-3 px-4 text-sm">
                                                        <span
                                                            className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${feeTypeMeta(
                                                                item.pml_fee_type
                                                            ).className}`}
                                                        >
                                                            {feeTypeMeta(item.pml_fee_type).label}
                                                        </span>
                                                    </td>
                                                    <td className="py-3 px-4 text-sm">
                                                        <span
                                                            className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${
                                                                item.data_status === "active"
                                                                    ? "bg-green-100 text-green-700"
                                                                    : "bg-red-100 text-red-700"
                                                            }`}
                                                        >
                                                            {item.data_status}
                                                        </span>
                                                    </td>
                                                    <td className="py-3 px-4 text-sm">
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                router.visit(`/panel/payment-method-lists/${item.pml_id}/edit`)
                                                            }
                                                            className="inline-flex items-center rounded-lg border border-layer-line px-2.5 py-1.5 text-xs font-medium text-layer-foreground hover:bg-layer-hover"
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
